module.exports = __webpack_public_path__ + "static/img/jianshiClick.c54ec35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/jianshiClick.png
// module id = n6IB
// module chunks = 0